import { Box, Flex, Text, Tooltip } from '@chakra-ui/react';
import { ButtonIcon, ButtonText } from '@morressier/alembic';
import RecommendationBadge from '../RecommendationBadge';
import dateFormat from 'dateformat';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowDownToBracket,
  faCopy
} from '@fortawesome/pro-regular-svg-icons';
import Divider from '../Divider';
import {
  IPeerReviewParticipant,
  ISubmissionFile
} from '@publishing-engine/domain/models';
import { useState } from 'react';
import ShowAttachementFiles from './ShowAttachementFiles';
import { useCopyToClipboard } from 'src/hooks/useCopyToClipboard';
interface Props {
  participants: IPeerReviewParticipant[];
}

export const ParticipantReviewerName = (  {participant, index}:
  {participant: IPeerReviewParticipant;
  index: number}
) => {
  const participantFullName = `${participant.reviewer.firstName} ${participant.reviewer.lastName}`;
  const invitedUser =
    participant.reviewer.firstName.toLowerCase() === 'invited';

  return (
    <Tooltip label={participant.reviewer.email} placement="auto" hasArrow>
      <Text textStyle="textBody" width={'fit-content'}>
        {invitedUser ? `Reviewer ${index + 1}` : participantFullName}
      </Text>
    </Tooltip>
  );
};

const PeerReviewFullView = ({ participants }: Props) => {
  const [showAttachments, setShowAttachments] = useState<
    ISubmissionFile[] | null
  >(null);
  const { copy } = useCopyToClipboard();
  return (
    <>
      {showAttachments && (
        <ShowAttachementFiles
          attachments={showAttachments}
          onClose={() => setShowAttachments(null)}
        />
      )}
      {participants.map(
        (participant, index) =>
          participant.reviewerRecommendationData && (
            <>
              <Flex justifyContent="space-between" padding={2} gap={3}>
                <Flex gap={3} alignItems="center">
                  <Text textStyle="headingLine">{index + 1}</Text>
                 <ParticipantReviewerName participant={participant} index={index} />
                  {participant.reviewerRecommendationData && (
                    <Box>
                      <RecommendationBadge
                        recommendation={
                          participant.reviewerRecommendationData
                            .recommendation ?? ''
                        }
                      />
                    </Box>
                  )}

                  <Text textStyle="textContext">
                    {dateFormat(
                      participant.reviewerRecommendationData.date,
                      'mmm d, yyyy'
                    )}
                  </Text>
                </Flex>
                <Flex alignContent="flex-end" flexDirection="column">
                  {(participant?.reviewerRecommendationData.reviewerAttachments
                    ?.length ?? 0) > 0 && (
                    <Flex gap={1} alignItems="center">
                      <Text textStyle="headingLine" isTruncated>
                        Review Attachments:
                      </Text>
                      <ButtonText
                        rightIcon={
                          <FontAwesomeIcon icon={faArrowDownToBracket} />
                        }
                        disabled={
                          (participant?.reviewerRecommendationData
                            .reviewerAttachments?.length ?? 0) === 0
                        }
                        onClick={() =>
                          setShowAttachments(
                            participant?.reviewerRecommendationData
                              ?.reviewerAttachments || []
                          )
                        }
                      >
                        {participant?.reviewerRecommendationData
                          ?.reviewerAttachments?.length ?? 0}{' '}
                        Files
                      </ButtonText>
                    </Flex>
                  )}
                  {(participant?.reviewerRecommendationData
                    .reviewerAttachmentsEditor?.length ?? 0) > 0 && (
                    <Flex gap={1} alignItems="center">
                      <Text textStyle="headingLine" isTruncated>
                        Reviewer Attachments (Editor-only):
                      </Text>
                      <ButtonText
                        rightIcon={
                          <FontAwesomeIcon icon={faArrowDownToBracket} />
                        }
                        disabled={
                          (participant?.reviewerRecommendationData
                            .reviewerAttachmentsEditor?.length ?? 0) === 0
                        }
                        onClick={() =>
                          setShowAttachments(
                            participant?.reviewerRecommendationData
                              ?.reviewerAttachmentsEditor || []
                          )
                        }
                      >
                        {participant?.reviewerRecommendationData
                          ?.reviewerAttachmentsEditor?.length ?? 0}{' '}
                        Files
                      </ButtonText>
                    </Flex>
                  )}
                </Flex>
              </Flex>
              <Flex padding={2}>
                <Flex flexDirection="column" gap={1}>
                  <Flex gap={2} alignItems="center">
                    <Text textStyle="headingLine">Comment for Author(s)</Text>
                    <ButtonIcon
                      ariaLabel="Copy"
                      icon={<FontAwesomeIcon icon={faCopy} />}
                      variant="primary"
                      onClick={() =>
                        copy(
                          participant?.reviewerRecommendationData
                            ?.feedbackForAuthors.original ?? ''
                        )
                      }
                      disabled={
                        !participant.reviewerRecommendationData
                          .feedbackForAuthors.original
                      }
                    />
                  </Flex>
                  <Text>
                    {participant.reviewerRecommendationData.feedbackForAuthors
                      .original || '--'}
                  </Text>
                  <Text textStyle="headingLine">Comment for Staff</Text>
                  <Text>
                    {participant.reviewerRecommendationData
                      .feedbackForEditors || '--'}
                  </Text>
                </Flex>
              </Flex>
              {participants.length - 1 !== index && <>{Divider}</>}
            </>
          )
      )}
    </>
  );
};
export default PeerReviewFullView;
